// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__M59sh","footer":"ChangeClinic_footer__3SihE"};